import React from "react"
import { connect } from "react-redux"
import { MainActions, AuthActions } from "redux-store/models"
import { Modal } from "antd"
import images from "themes/images"
import { Document, Page } from "react-pdf"
import ReactToPrint from "react-to-print"
import { b64toBlob } from "utils"
import { capitalize } from "lodash"
import DownloadVisure from "shared-components/DownloadVisure"
import PrintTicketPin from "../../shared-components/Tickets/PrintTicketPin"
import PrintTicketTopUp from "../../shared-components/Tickets/PrintTicketTopUp"
import PrintTicketBolletino from "../../shared-components/Tickets/PrintTicketBolletino"
import PrintTicketSpedizioni from "../../shared-components/Tickets/PrintTicketSpedizioni"
import PrintTicketPaysafe from "../../shared-components/Tickets/PrintTicketPaysafe"
import PrintTicketGiftCard from "../../shared-components/Tickets/PrintTicketGiftCard"
import { withRouter } from "react-router"
import BetFlagDirectTicket from "../../shared-components/Tickets/BetFlagDirectTicket"
import CreateGiftCardTicket from "../../shared-components/Tickets/CreateGiftCardTicket"
import TicketLayout from "../../shared-components/Tickets/TicketLayout"
import PrintTicketVisure from "../../shared-components/Tickets/PrintTicketVisure"

class PrintTicket extends React.Component {
  printPdfReceipt = (data, type) => {
    if (data.receipt_type === "base64") {
      var myBlob = b64toBlob(data.receipt, "application/pdf")
      var blobUrl = URL.createObjectURL(myBlob)
      if (type === "print") {
        window
          .open(
            blobUrl,
            "_blank",
            "toolbar=no,scrollbars=no,resizable=no,top=50,left=500,width=700,height=700"
          )
          .print()
      }
      if (type === "download") {
        const linkSource = `data:application/pdf;base64,${data.receipt}`
        const downloadLink = document.createElement("a")
        const fileName = "Ticket.pdf"

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      }
      if (type === "return") {
        return blobUrl
      }
    }
  }

  returnCoffeeStringHtml = (coffeDetails) => {
    let htmlTemplate = ""
    const unAllowedValues = ["created_at", "updated_at", "id", "barcode"]
    Object.keys(coffeDetails).forEach((coffeDetailKey) => {
      if (!unAllowedValues.includes(coffeDetailKey)) {
        htmlTemplate += `<br/>${coffeDetailKey
          .split("_")
          .map((word) => capitalize(word))
          .join(" ")} <div class='marginB'></div><div class='marginC'>${
          coffeDetails[coffeDetailKey]
        }</div><br/>`
      }
    })
    return htmlTemplate
  }

  getPrintBtn = () => {
    const { paymentsFromCode, bolletiniBianchi } = this.props
    const arr = paymentsFromCode?.receipt ? paymentsFromCode : bolletiniBianchi

    return arr?.message === "Reserve processed successfully" ? (
      <div style={{ display: "flex" }}>
        <div
          className="printBtn acceta"
          onClick={() => {
            arr.service_type === "TOPUP" || arr.type === "Phone Recharge"
              ? this.props.captureRechargeMobileSim(arr.payload)
              : this.props.bolletinoCapture(arr.payload)
          }}
        >
          ACCETA
        </div>
        <div
          className="printBtn annulla"
          onClick={() => {
            this.props.setBolletiniBianchi([])
            this.props.setBolletiniPremercati([])
            this.props.setRechargeMobile([])
          }}
        >
          ANNULLA
        </div>
      </div>
    ) : (
      <ReactToPrint
        trigger={() => <div className="printBtn">Print</div>}
        content={() => this.componentRef}
        bodyClass="afterprint"
        // copyStyles="false"
      />
    )
  }

  generateTicketBody = (barcode, scontrino) => {
    const { arr } = this.props

    console.log(arr)
    console.log(arr.service_type)

    const isVisure = ["JSON", "json_bitnovo"].includes(arr.receipt_type)

    const ticketMapping = {
      // base64: this.renderPdfReceipt(arr),
      Betflag: <BetFlagDirectTicket arr={arr} />,
      json_spedizionepro: <PrintTicketSpedizioni arr={arr} />,
      PIN: arr?.paysafe ? (
        <PrintTicketPaysafe arr={arr} barcode={barcode} />
      ) : (
        <PrintTicketTopUp arr={arr} barcode={barcode} />
      ),
      TOPUP: <PrintTicketTopUp arr={arr} barcode={barcode} />,
      EPay: <PrintTicketTopUp arr={arr} barcode={barcode} />,
      Aircash: <PrintTicketGiftCard arr={arr} barcode={barcode} />,
      MrPayCard: <CreateGiftCardTicket arr={arr} />,
      PaymentSystem: <CreateGiftCardTicket arr={arr} />,
    }

    if (arr.type && arr.type.includes("Bolletino")) {
      ticketMapping["Bolletino"] = <PrintTicketTopUp arr={arr} />
    }

    let ticketComponent = null

    if (arr.receipt_type === "base644") {
      ticketComponent = ticketMapping["base64"]
    } else {
      ticketComponent =
        ticketMapping[arr.type] ||
        ticketMapping[arr.service_type] ||
        ticketMapping[arr.receipt_type] ||
        ticketMapping["Bolletino"] ||
        this.renderFallbackTicket(arr)
    }

    if (isVisure) {
      ticketComponent = <PrintTicketVisure arr={arr} />
    }

    return (
      <TicketLayout arr={arr}>
        {ticketComponent}

        <div
          style={{ marginTop: 20 }}
          dangerouslySetInnerHTML={{
            __html: (
              (scontrino
                ? scontrino
                : arr?.content_scontrino !== "credits"
                ? arr?.content_scontrino
                : "") || ""
            ).replace(/<p>/g, '<p style="margin-bottom: 5px;">'),
          }}
        />

        <div className="barcode-info">
          {isVisure && (
            <p>
              Se non hai dato una mail per scaricare il pdf puoi usare la ricerca
              dello scontrino su{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${window.location.origin}/#/transazioni/qrcodereader`}
              >
                {`${window.location.host}/#/transazioni/qrcodereader`}
              </a>{" "}
            </p>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
              justifyContent: "space-between",
              width: "100%",
              paddingTop: 10,
            }}
          >
            {/* Barcode */}
            {!(
              arr.type === "betflag-direct" ||
              arr.message === "Reserve processed successfully"
            ) && this.renderBarcode(barcode)}

            {/* QR Code */}
            {!(
              arr.receipt_type === "json_spedizionepro" ||
              arr.type === "betflag-direct" ||
              arr.message === "Reserve processed successfully"
            ) && this.renderQrCode(barcode)}
          </div>
        </div>
      </TicketLayout>
    )
  }

  componentDidMount() {
    const { match, location } = this.props
    const { id } = match.params
    const queryParams = new URLSearchParams(location.search)
    const type = queryParams.get("type")

    this.props.getCodiceTicket(id, type)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.print !== this.props.print) {
      document.querySelector(".printBtn").click()
    }
  }

  render() {
    const { arr, onlyForPrint, scontrino } = this.props
    const barcode = Array.isArray(arr) ? arr[0]?.barcode : arr?.barcode || 1
    const receipt = Array.isArray(arr) ? arr[0]?.receipt : arr?.receipt

    return (
      !!(barcode && receipt) &&
      (onlyForPrint ? (
        <div style={{ opacity: 0, visibility: "hidden", width: 0, height: 0 }}>
          {this.generateTicketBody(barcode, scontrino)}
        </div>
      ) : (
        <Modal
          width={arr.service_type === "gift_cards" ? 494 : 494}
          title={null}
          visible={
            this.props.screenWidth > 1320 && this.props.forAdmin ? false : true
          }
          onCancel={this.closeModal}
          footer={null}
        >
          {this.generateTicketBody(barcode, scontrino)}
        </Modal>
      ))
    )
  }
}

const mapsStateToProps = (state) => ({
  isShowing: state.main.isShowing,
  service_id: state.auth.service_id,
  skinExtras: state.auth.skinExtras,
  screenWidth: state.main.screenWidth,
  activeSkinId: state.main.activeSkinId,
  skins: state.auth.skinList,
  paymentsFromCode: state.auth.paymentsFromCode,
  bolletiniBianchi: state.auth.bolletiniBianchi,
})

export default withRouter(
  connect(mapsStateToProps, { ...AuthActions, ...MainActions })(PrintTicket)
)
